import { Form, Radio } from 'antd';

import { SCRAPING_SORT } from '../../types';

export const SortField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <Form.Item label="Sort" name="sort" required={required}>
      <Radio.Group>
        <Radio value={SCRAPING_SORT.RECENT} defaultChecked>
          Recent
        </Radio>
        <Radio value={SCRAPING_SORT.ACCURACY}>Accuracy</Radio>
      </Radio.Group>
    </Form.Item>
  );
};
